import { KbContextSearch } from "./KbContextSearch";

export class KbContext {
  public link: string;
  public pageName: string;
  public search: KbContextSearch;
  public userCountryCode: string;
  public iae: boolean;

  public constructor() {
    this.link = "";
    this.pageName = "";
    this.search = new KbContextSearch();
    this.userCountryCode = "";
    this.iae = true;
  }

  public static fromJson(jsonString: string): KbContext {
    const kbContext = new KbContext();
    const data = JSON.parse(jsonString);

    kbContext.link = data.link || "";
    kbContext.pageName = data.page_name || "";
    kbContext.userCountryCode = data.user_country_code || "";
    kbContext.iae = data.iae || true;

    if (
      data.search &&
      data.search.departure_city_name &&
      data.search.arrival_city_name
    ) {
      const kbContextSearch = new KbContextSearch();

      kbContextSearch.departureCity = data.search.departure_city_name;
      kbContextSearch.arrivalCity = data.search.arrival_city_name;

      kbContext.search = kbContextSearch;
    }

    return kbContext;
  }
}
